module.exports = __webpack_public_path__ + "media/assets/background-e6ed90fa.jpg";